import { CounterMedium } from '../../automationObjects/Devices/CounterMedium';
import { CounterType } from '../../automationObjects/Devices/CounterType';
import { themedUseStyletron } from '../../theme/customTheme'
import { getMediumColor } from '../../utils/colorUtils'



function  useGetMediumColor(medium: CounterMedium, type: CounterType): [string] {
  const[css,theme] = themedUseStyletron();

  if ( type === CounterType.Producer)
    return [theme.colors.positive];
  return [getMediumColor(medium,type, theme)]
}

export default useGetMediumColor     